import React from 'react';
import InviteFriends from '../components/Invite/InviteFriends'


function Invite({ location, match }) {
  return <InviteFriends />
}

export default Invite;
